import { STORYBLOK_VERSION } from "@config/config"
import { ISbStoriesParams } from "@storyblok/react/rsc"

/** How often the server asks Storyblok whether anything was published. */
const PUBLISH_CHECK_MS = 60_000

/** Drafts are never cached by the SDK, so they only need a time bucket to bust the edge. */
const DRAFT_WINDOW_MS = 10_000

// The space cv, which Storyblok bumps on every publish. 0 until the first check succeeds.
let spaceCv = 0
let lastCheck = 0

const checkForPublish = () => {
  const token = process.env.STORYBLOK_ACCESS_TOKEN
  if (typeof window !== "undefined" || !token || Date.now() - lastCheck < PUBLISH_CHECK_MS) return
  lastCheck = Date.now()

  fetch(`https://api.storyblok.com/v2/cdn/spaces/me?token=${token}`, { cache: "no-store" })
    .then(response => (response.ok ? response.json() : Promise.reject(response.status)))
    .then((data: { space?: { version?: number } }) => {
      spaceCv = data.space?.version ?? 0
    })
    // Without a known cv, fall back to the time bucket: fresh, just more requests.
    .catch(() => {
      spaceCv = 0
    })
}

/**
 * The `cv` every Storyblok read carries. Published reads use the space cv, so their URLs stay the
 * same until the next publish and the client cache in `src/lib/storyblok.ts` answers repeats.
 */
export const cacheVersion = (version: string | undefined = STORYBLOK_VERSION) => {
  checkForPublish()
  return version === "published" && spaceCv ? spaceCv : Math.floor(Date.now() / DRAFT_WINDOW_MS)
}

export const defaultSbParams: ISbStoriesParams = {
  version: STORYBLOK_VERSION,
  from_release: process.env.STORYBLOK_CONTENT_PIPELINE,
  // A getter so every spread reads a current cv rather than the one from import time.
  get cv() {
    return cacheVersion()
  }
}
